import { MaterialIcon } from "@website/icons/material";
import { LazyImage } from "@website/ui/lazy-image";
import styles from "@website/widget/filter/index.module.scss";
import IranMapImage from "libs/widget/assets/images/iran_map.png";

interface Properties {
  onClick: () => void;
  label: string;
}

export function FilterMap({ onClick, label }: Properties) {
  return (
    <div className={styles["filter-map-container"]} onClick={onClick}>
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center gap-2">
          <MaterialIcon className="text-2xl" name="map" variant="outlined" />
          <span className="font-medium">{label}</span>
        </div>
        <MaterialIcon
          className="text-secondary text-2xl"
          name="chevron_left"
          variant="fill"
        />
      </div>

      <div className="h-[104px] w-full overflow-hidden rounded-lg">
        <LazyImage
          alt="iran_map"
          className="size-full object-cover object-center"
          src={IranMapImage.src}
        />
      </div>
    </div>
  );
}
